import { render, staticRenderFns } from "./CirclesLoader.vue?vue&type=template&id=b829b5ec&scoped=true"
import script from "./CirclesLoader.vue?vue&type=script&lang=js"
export * from "./CirclesLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b829b5ec",
  null
  
)

export default component.exports